import axios from "src/lib/axios"

export const getAllOrder = ({
  keyword = null,
  page = null,
  page_size = null,
  order_case = "desc",
  status = 'all'
}) => axios.get(`/wallplast/order`, {params: {
  keyword: keyword,
  page: page,
  page_size: page_size,
  order_case: order_case,
  status: status
}})

export const getOrder = (id) => axios.get(`/wallplast/order/${id}`)